export const PAYMENT_TERM_SPOT = 'Spot'
